
import { Component, ElementRef, Input, OnChanges, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { AppService } from 'src/app/app.service';
import * as XLSX from 'xlsx';
import * as JSZip from 'jszip';
import { utils, writeFile, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { TableService } from '../../services/tableService/table.service';
import { ExportPdfTableComponent } from 'src/app/export-pdf-table/export-pdf-table.component';
import { ExportPdfFixedComponent } from '../export-pdf-fixed/export-pdf-fixed.component';
import { ExportPdfLtlComponent } from '../export-pdf-ltl/export-pdf-ltl.component';
import { ExportAditionalChargesComponent } from '../export-aditional-charges/export-aditional-charges.component';
import { TableLayoutHelper } from 'src/app/shared/helpers/table-layout.helper';
import { HttpService } from '../../services/http.service';
import { PDFDocument } from 'pdf-lib';

@Component({
  selector: 'app-export-to-pdf',
  standalone: false,
  templateUrl: './export-to-pdf.component.html',
  styleUrl: './export-to-pdf.component.scss'
})
export class ExportToPdfComponent implements OnChanges{

  @ViewChild('container') content: ElementRef | any;
  @ViewChildren(ExportPdfTableComponent) ftl!: QueryList<ExportPdfTableComponent> // to apply number of timmes on ftl
  @ViewChildren(ExportPdfLtlComponent) ltl!: QueryList<ExportPdfLtlComponent>
  @ViewChildren(ExportPdfFixedComponent) fixed!: QueryList<ExportPdfFixedComponent>
  @ViewChildren(ExportAditionalChargesComponent) additoinalCharge!: QueryList<ExportAditionalChargesComponent>
  
  @Input() data:any;
  private spread:any;
  private subscription:any;
  public exportPDFTableList:any;
  mauntList: any;
  scaleFactor: any;
  files: any = [];

  constructor(public appService:AppService, public tableService:TableService, private renderer: Renderer2, private httpService: HttpService) {
    this.subscription = this.appService.fileExportEmit.subscribe((evt:any) =>{      
      if(evt === 'PDF'){
        this.files = [];
        this.onSavePDF();
      }
      else{
        this.onSaveExcel();
      }
    })
    appService.isLoading=true;
   
    setTimeout(() => {
      this.exportPDFTableList = this.appService.exportPDFTableList;        
      appService.isLoading=false;   
      this.content.nativeElement.style.display = 'none'; 
      // this.onSavePDF();
    }, 0);
   
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['data']?.currentValue){
      this.data = changes['data'].currentValue;
    }
  }


public onSavePDF() {
  this.appService.isLoading = true;
  this.appService.raIsLoading = true;

  (async () => {
  try {
    await this.getAttachmentFile();
    await this.createPdf(); 
  } catch (error) {
    console.error('Error during PDF generation:', error);
  } finally {
    this.appService.isLoading = false;
    this.appService.raIsLoading = false;
  }
})();

}


private async createPdf() {
  this.content.nativeElement.style.display = 'block';
  this.renderer.setStyle(document.body, 'pointer-events', 'none');

  const tableHelper = TableLayoutHelper;
  let modifiedTables: HTMLElement[] = [];
  let alignedRows: HTMLElement[] = [];

  try {

    await new Promise(resolve => setTimeout(resolve, 200));
    const components: HTMLElement[] = Array.from(
      this.content.nativeElement.querySelectorAll('.table-matrix') as NodeListOf<HTMLElement>
    ).filter(el => el.offsetParent !== null);

    if (components.length === 0) {
      this.appService.isLoading = false;
      this.appService.raIsLoading = false;
      this.content.nativeElement.style.display = 'none';
      this.renderer.setStyle(document.body, 'pointer-events', 'auto');
      return;
    }
    
    modifiedTables = components.flatMap(component =>
      tableHelper.addMarginToTables(component)
    );
    alignedRows = components.flatMap(component =>
      tableHelper.alignDivToBottomOfPage(component, 20)
    );

    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'px',
      format: [1200, 900], 
      putOnlyUsedFonts: true,
      floatPrecision: 8, 
      compress: true
    });
  
    const verticalMargin = 15;
    const horizontalMargin = 20;
    const pdfWidth = 1160; 
    const availableHeight = 860;
    const maxCanvasHeight = 4096; // Browser canvas size limit

    this.applyPdfStyles();
  
    for (let i = 0; i < components.length; i++) {
      const component = components[i] as HTMLElement;
      
      component.style.width = '1200px';
      component.style.maxHeight = 'none';
      component.style.height = 'auto';
      
      // Wait for layout to settle
      await new Promise(resolve => requestAnimationFrame(resolve));
      
      let canvas: HTMLCanvasElement;
      try {
        canvas = await html2canvas(component, { 
          scale: 1.5, 
          useCORS: true, 
          logging: false, 
          allowTaint: true,
          backgroundColor: '#ffffff',
          removeContainer: false,
          foreignObjectRendering: false,
          width: component.scrollWidth,
          height: component.scrollHeight
        });
      } catch (canvasError) {
        console.error('html2canvas error:', canvasError);
        continue; 
      }

  
      const imgHeight = (canvas.height / canvas.width) * pdfWidth;
      let remainingHeight = imgHeight;
      let currentY = verticalMargin; 
      let contentPosition = 0;
  
      while (remainingHeight > 0) {
        if (currentY > verticalMargin || i > 0) {
          pdf.addPage();
          currentY = verticalMargin; 
        }
  
        const sliceHeight = Math.min(remainingHeight, availableHeight);
        const canvasSlice = document.createElement('canvas');
        const sliceCtx = canvasSlice.getContext('2d', { 
          alpha: false,
          willReadFrequently: false 
        });
        
        if (!sliceCtx) {
          console.error('Failed to get canvas context');
          break;
        }
        
        // Calculate actual canvas dimensions
        const actualCanvasHeight = Math.min(
          (sliceHeight / pdfWidth) * canvas.width,
          maxCanvasHeight
        );
        
        canvasSlice.width = canvas.width;
        canvasSlice.height = actualCanvasHeight;

        try {
          sliceCtx.drawImage(
            canvas, 
            0, 
            contentPosition, 
            canvas.width, 
            actualCanvasHeight, 
            0, 
            0, 
            canvasSlice.width, 
            canvasSlice.height
          );

          await new Promise(resolve => requestAnimationFrame(resolve));
          const sliceImgData = canvasSlice.toDataURL('image/png', 1.0);

          try {
            pdf.addImage(
              sliceImgData, 
              'PNG',
              horizontalMargin, 
              currentY, 
              pdfWidth, 
              sliceHeight, 
              undefined, 
              'FAST'
            );
          } catch (addImageError) {
            console.error('Error adding image to PDF:', addImageError);
          }
          
        } catch (drawError) {
          console.error('Error during canvas operations:', drawError);
        } finally {
          // Clean up canvas slice
          canvasSlice.width = 0;
          canvasSlice.height = 0;
        }
  
        contentPosition += actualCanvasHeight;
        remainingHeight -= sliceHeight; 
        currentY += sliceHeight; 
      }
    }
  
    const totalPages = pdf.getNumberOfPages();
    for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
      pdf.setPage(pageNum); 
      const footerText = `Page ${pageNum} of ${totalPages}`;
      pdf.setFontSize(15);
      pdf.text(footerText, 600, 890, { align: 'center' }); 
    }
    const pdfBytes = pdf.output('arraybuffer');

    if (this.files && this.files.length > 0) {
      await this.mergePdfs(pdfBytes, this.files);
    } else {
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      saveAs(blob, `${this.data?.RateAgreementNumber}.pdf`);
    }    
    
  } catch (error) {
    console.error('Error in PDF generation:', error);
    throw error; // Re-throw to be caught by calling function
  } finally {
    const allModifiedElements = [...modifiedTables, ...alignedRows];
    tableHelper.restoreTableStyles(allModifiedElements);
    this.renderer.setStyle(document.body, 'pointer-events', 'auto');
    this.content.nativeElement.style.display = 'none';
  }
}
  /**
 * Merges the generated PDF with attachment PDFs
 * @param mainPdfBytes - The main PDF as ArrayBuffer
 * @param attachmentFiles - Array of attachment files
 */
private async mergePdfs(mainPdfBytes: ArrayBuffer, attachmentFiles: any[]): Promise<void> {
  try {
    const mainPdfDoc = await PDFDocument.load(mainPdfBytes);
    const mergedPdf = await PDFDocument.create();
    const mainPdfPages = await mergedPdf.copyPages(mainPdfDoc, mainPdfDoc.getPageIndices());
    mainPdfPages.forEach(page => mergedPdf.addPage(page));

    for (const file of attachmentFiles) {
      try {
        const fileArrayBuffer = await this.getFileAsArrayBuffer(file);

        const attachmentPdf = await PDFDocument.load(fileArrayBuffer);

        const attachmentPages = await mergedPdf.copyPages(attachmentPdf, attachmentPdf.getPageIndices());
        attachmentPages.forEach(page => mergedPdf.addPage(page));
      } catch (err) {
        console.error(`Error processing attachment file:`, err);
      }
    }

    const mergedPdfBytes = await mergedPdf.save();
    const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
    saveAs(blob, `${this.data?.RateAgreementNumber}.pdf`);

  } catch (error) {
    console.error('Error merging PDFs:', error);
    const blob = new Blob([mainPdfBytes], { type: 'application/pdf' });
    saveAs(blob, `${this.data?.RateAgreementNumber}.pdf`);
  }
}

/**
 * Converts a File object to ArrayBuffer
 * @param file - The file to convert
 * @returns Promise resolving to ArrayBuffer
 */
private getFileAsArrayBuffer(file: any): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    // Handle if file is already an ArrayBuffer
    if (file instanceof ArrayBuffer) {
      resolve(file);
      return;
    }

    if (file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as ArrayBuffer);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
      return;
    }

    if (typeof file === 'string' && file.startsWith('data:')) {
      try {
        const base64 = file.split(',')[1];
        const binary = atob(base64);

        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        resolve(bytes.buffer);
      } catch (error) {
        reject(error);
      }
      return;
    }

    reject(new Error('Unknown file format. Expected File, Blob, ArrayBuffer, or base64 string.'));
  });
}


private getAttachmentFile(): Promise<void> {
  return new Promise((resolve, reject) => {
    this.httpService
      .getFileFromBlob('attachment', this.data?.RateAgreementID)
      .subscribe({
        next: (blob: Blob) => {
          if (blob.type === 'text/html') {
            resolve(); return;
          }

          const zipReader = new FileReader();
          zipReader.onload = () => {
            const zipData = zipReader.result as ArrayBuffer;
            this.extractFilesFromZip(zipData)
              .then(() => resolve())
              .catch((err) => reject(err));
          };
          zipReader.onerror = (err) => reject(err);
          zipReader.readAsArrayBuffer(blob);
        },
        error: (err) => reject(err)
      });
  });
}

private extractFilesFromZip(zipData: ArrayBuffer): Promise<void> {
  const zip = new JSZip();

  return zip.loadAsync(zipData).then((zip: any) => {
    const filePromises: Promise<void>[] = [];

    zip.forEach((relativePath: any, zipEntry: any) => {
      if (zipEntry.name.toLowerCase().endsWith('.pdf')) { // filter for PDFs
        const filePromise = zipEntry.async('blob').then((fileData: any) => {
        if (fileData.size <= 500 * 1024) {
            this.files = [...this.files, new File([fileData], zipEntry.name)]
              .sort((a, b) => a.name.localeCompare(b.name));
          }
        });
        filePromises.push(filePromise);
      }
    });

    return Promise.all(filePromises).then(() => {});
  });
}

  getHtml(htmlString: string) {
    return htmlString.replace(/\n/g, "<br>");
  }

  
public onSavePDF1(){
  this.subscription.unsubscribe();
  let content=this.content.nativeElement;
  if (!content) {
    console.error('Content element not found!');
    return;
  }
      // Save original display and visibility styles
      const components = document.getElementsByClassName('table-matrix');
      if (!components || components.length === 0) {
        console.error('No components found for export!');
        return;
      }
    const originalDisplay = content.style.display;

    // Temporarily make the element visible
    content.style.display = 'block';  // or 'inline-block', depending on your layout
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = 210;
    const pdfHeight = 297;
    const horizontalMargin = 5;
    const verticalMargin = 10;
  
    const processComponent = (component: HTMLElement, index: number) => {
      return new Promise<void>((resolve, reject) => {
    html2canvas(content, { scale: 3 }).then((canvas) => {
      const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size PDF in mm  
      const pdfWidth = 210; // A4 width in mm
      const pdfHeight = 297; // A4 height in mm
      const horizontalMargin = 5; // Reduced left and right margin
      const verticalMargin = 10; // Top and bottom margin
     
      const pageHeightInPx = (canvas.width / (pdfWidth - 2 * horizontalMargin)) * (pdfHeight - 2 * verticalMargin);
      let currentHeight = 0;
      const totalPages = Math.ceil(canvas.height / pageHeightInPx); // Calculate total pages
      let currentPage = 0; // Track current page
     
      while (currentHeight < canvas.height) {
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        pageCanvas.height = Math.min(pageHeightInPx, canvas.height - currentHeight);
        const context = pageCanvas.getContext('2d');

        if (context) {
          context.drawImage(canvas, 0,currentHeight,canvas.width,
          pageCanvas.height,0, 0,canvas.width, pageCanvas.height
        );

        const imgData = pageCanvas.toDataURL('image/png');
        // if (currentHeight > 0) pdf.addPage();
        if (currentPage > 0) pdf.addPage();
          pdf.addImage( imgData,'PNG', horizontalMargin,verticalMargin, pdfWidth - 2 * horizontalMargin,
            (pageCanvas.height / canvas.width) * (pdfWidth - 2 * verticalMargin));

            currentPage++;
            const footerText = `Page ${currentPage} of ${totalPages}`;
            pdf.setFontSize(10); // Set font size for footer
            pdf.text(footerText, pdfWidth / 2, pdfHeight - 5, { align: 'center' }); // Centered at bottom
        }
        currentHeight += pageHeightInPx;
      }
      // Save PDF
      pdf.save(`${this.data?.RateAgreementNumber}.pdf`);
    }).catch((error:any) => {
      // console.error('Error exporting PDF:', error);
    })
    .finally(() => {
      // Restore the original display and visibility styles
      content.style.display = originalDisplay;
    });
  });
};

// Process each component in sequence
const promises = Array.from(components).map((component, index) =>
  processComponent(component as HTMLElement, index)
);

Promise.all(promises)
  .then(() => {
    pdf.save(`${this.data?.RateAgreementNumber}.pdf`);
  })
  .catch(error => {
    // console.error('Error exporting PDF:', error);
  });
}
  
  private applyPdfStyles() {
    const newFontSize = 14;
    this.tableService.newFontSize = newFontSize;
    this.tableService.newHeight = 1.5 * newFontSize;
    
    let headerElements = document.getElementsByClassName('new-font-header');
    for (let i = 0; i < headerElements.length; i++) {
      (headerElements[i] as HTMLElement).style.fontSize = `${newFontSize + 2}px`;
      (headerElements[i] as HTMLElement).style.lineHeight = `${1.5 * newFontSize}px`;
      (headerElements[i] as HTMLElement).style.marginBottom = '4px';
    }
    
    let textElements = document.getElementsByClassName('new-font-size');
    for (let i = 0; i < textElements.length; i++) {
      (textElements[i] as HTMLElement).style.fontSize = `${newFontSize}px`;
      (textElements[i] as HTMLElement).style.lineHeight = `${1.5 * newFontSize}px`;
      (textElements[i] as HTMLElement).style.marginBottom = '2px';
    }
    
    this.ftl?.forEach((ftl: any) => {
      ftl.styleUpdate();
    });
    this.fixed?.forEach((fixed: any) => {
      fixed.styleUpdate();
    });
    this.ltl?.forEach((ltl: any) => {
      ltl.styleUpdate();
    });
    this.additoinalCharge?.forEach((charge: any) => {
      if (charge.styleUpdate) {
        charge.styleUpdate();
      }
    });
  }
 
  onSaveExcel() {
    this.subscription.unsubscribe();
    const content = this.content.nativeElement;
    const workbook = XLSX.utils.table_to_book(content, { sheet: 'Sheet1' });
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = this.data?.RateAgreementNumber+'.xlsx';

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(data);
    link.download = fileName;
    link.click();

  }

  delayRender(index: number) {
    setTimeout(() => {
      // Access the specific item in exportPDFTableList based on the index and render the appropriate component
      const item = this.appService.exportPDFTableList[index];
      if (item.type === 'ltl') {
        // Render app-export-pdf-ltl component
      } else if (item.type === 'fixed') {
        // Render app-export-pdf-fixed component
      } else if (item.type === 'ftl') {
        // Render app-export-pdf-table component
      }
    }, 1000 * index); // Delay each item based on its index position
  }
}

